import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

// declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public profileData: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public cuetData: BehaviorSubject<string> = new BehaviorSubject<string>('');
 

  constructor(public http:HttpClient, public AppConfig:AppConfig) { }

  
  verifyToken(token:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      })
    };

    return this.http.get('https://www.googleapis.com/oauth2/v2/userinfo', httpOptions)
      .pipe(map((response: any) => response));
  }

  savescroll(data:any){
    this.cuetData.next(data)
      }

  userProfile(data:any){
    this.profileData.next(data)
      }

      getLoginImage() {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
          })
        };
      
        return this.http.get(this.AppConfig.API_ENDPOINT + 'LoginImageDetails', httpOptions)
          .pipe(map((response: any) => response));
      }

  gmail_login(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };

  return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'gmail_custom_login?username='+reqData.username+'&gmail_id='+reqData.id+
  '&email='+reqData.email+'&gmail_pic='+reqData.gmail_pic, httpOptions)
      .pipe(map((response: any) => response));
  }

  checkuser(id:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'facebookid?fb_id='+id, httpOptions)
        .pipe(map((response: any) => response));
  }


  login(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };

// if(reqData.email){
  return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'custom_login?username='+reqData.username+'&firstname='+
  reqData.firstname+'&lastname='+reqData.last_name+'&facebook_id='+reqData.id+'&email='+reqData.email+'&facebook_pic='+reqData.facebook_pic, httpOptions)
      .pipe(map((response: any) => response));
// }else{
//   return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'custom_login?username='+reqData.username+'&firstname='+
//   reqData.firstname+'&lastname='+reqData.last_name+'&facebook_id='+reqData.id+'&facebook_pic='+reqData.facebook_pic, httpOptions)
//       .pipe(map((response: any) => response));
// }
   
  }

  editProfile(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.put(this.AppConfig.LOGIN_ENDPOINT+'edit_profile', reqData, httpOptions)
        .pipe(map((response: any) => response));
  }


  loginFB(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.get('https://catonlinecoaching.com/social-auth/login/facebook', httpOptions)
        .pipe(map((response: any) => response));
  }

  applyInternship(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.post(this.AppConfig.API_ENDPOINT+'internship_application_create', reqData)
        .pipe(map((response: any) => response));
  }

  applyCallBack(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.post(this.AppConfig.API_ENDPOINT+'FranchiseCallBackList', reqData)
        .pipe(map((response: any) => response));
  }


  signinwithotop(mobileno:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'send_otp?phone_no='+mobileno, httpOptions)
        .pipe(map((res: any) => res));
        
  }


  verifyOTP(reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.post(this.AppConfig.LOGIN_ENDPOINT+'check_otp', reqData, httpOptions)
        .pipe(map((res: any) => res));
  }


  loginwithotop(mobileno:any,ip:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };
    return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'send_otp_new?phone_no='+mobileno+'&ip='+ip, httpOptions)
        .pipe(map((res: any) => res));
        
  }


  verifywithOTP(reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };
    return this.http.post(this.AppConfig.LOGIN_ENDPOINT+'check_otp_new', reqData, httpOptions)
        .pipe(map((res: any) => res));
  }


  createUser(reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.post(this.AppConfig.LOGIN_ENDPOINT+'user_register', reqData, httpOptions)
        .pipe(map((res: any) => res));
  }

  userRegister(reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json',

      })
    };


    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'UserRegister', reqData)
      // return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'UserRegister', reqData)
      .pipe(map((res: any) => res));
  }



  saveConfession(reqData:any) {
   
    return this.http.post(this.AppConfig.API_ENDPOINT+'ConfessionList', reqData)
        .pipe(map((res: any) => res));
  }


  getIPAddress()  
  {  
    return this.http.get("https://api.ipify.org/?format=json");  
  }  

  saveToken(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };


    return this.http.post(this.AppConfig.API_ENDPOINT+'FCMTokenPost', reqData, httpOptions)
        .pipe(map((res: any) => res));
  }

  saveLoginInfo(reqData:any, token:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token ' + token
      })
    };


    return this.http.post(this.AppConfig.API_ENDPOINT+'LoginActivityList', reqData, httpOptions)
        .pipe(map((res: any) => res));
  }


  mbacounsellingformsubmit(reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
    return this.http.post(this.AppConfig.API_ENDPOINT+'MbaEnquiryForm', reqData, httpOptions)
        .pipe(map((res: any) => res));
  } 


  getCities() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };
    return this.http.get(this.AppConfig.API_ENDPOINT+'CityGetAll', httpOptions)
        .pipe(map((res: any) => res));
  }

  initPixel(pixelId: any): void {
    (window as any).fbq('init', pixelId);
  }

  trackEvent(event: any, data?: any): void {
    (window as any).fbq('track', event, data);
  }

  loginWithUserid(reqdat:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };
    return this.http.post(this.AppConfig.LOGIN_ENDPOINT+'UserLoginWithIdAndPasswordOrPhoneNo', reqdat, httpOptions)
        .pipe(map((res: any) => res));

  }

  changePassword(token:any,reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token '+token
      })
    };
    return this.http.post(this.AppConfig.LOGIN_ENDPOINT+'PasswordChangeUserInUserapp', reqData, httpOptions)
        .pipe(map((res: any) => res));

  }

  // trackEvent(event: string, data: any = {}): void {
  //   // Ensure the Facebook Pixel script is loaded
  //   if (window.fbq) {
  //     // Track the event
  //     window.fbq('track', event, data);
  //   }
  // }

  userDetailsToDownload(reqdat:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };
    return this.http.post(this.AppConfig.API_ENDPOINT+'form_post', reqdat, httpOptions)
        .pipe(map((res: any) => res));

  }

  registerForSkills(reqdat:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      
      })
    };
    return this.http.post(this.AppConfig.API_ENDPOINT+'CreateLearningForFreeApi', reqdat, httpOptions)
        .pipe(map((res: any) => res));

  }

  comingSoonLead(reqdat:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'secret': 		'bbZR3jBS5LCUMxIGHB6iNvFZsKKDwlJc',
        'token': 		'XZzOamUNhW8n9G8r39UNPG0EB049YBYY'
        
      })
    };
    return this.http.post('https://itech-api-prod.iquanta.in/api/iskill/v1/form2/sent/enquiry', reqdat, httpOptions)
        .pipe(map((res: any) => res));

  }

  getIndianCities(){
    return this.http.get('https://media.iquanta.in/cities.json')
    .pipe(map((response: any) => response));
  }

}
